import Footer from "./Footer";
import Header from "./Header";
import MainAfroCiencia from "./Main/MainAfroCiencia";
function AfroCiencia(){
    return(

        <div>
            
            <Header />
            <MainAfroCiencia />
            <Footer />
        </div>  

    );
}

export default AfroCiencia;
